import { SocialMedia } from '@/modules/homepage/SocialMedia/SocialMedia';
import { SocialMediaMetadataInterface } from '@/types/homepage.types';

export const RenderSocialMedia = ({ socialMedias, title }: SocialMediaMetadataInterface) => {
  return <SocialMedia title={title} data={socialMedias} />;
};
